<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            服务对象统计表
        </div>
        <div style="padding: 20px;" class="summary8099">
            <div v-if="showModal" class="mask">
                <div class="lodingsIcon">
                    <i class="el-icon-loading"></i><span>正在处理，请等待。。。</span>
                </div>
            </div>
            <div>
                <el-row>
                    <div style="float:right">
                        <span class="demonstration">统计类别：</span>
                        <el-select v-model="tableClass" placeholder="请选择统计类别" @change='getTableClass' style="width:250px;margin-right:20px">
                            <el-option
                                    v-for="(item,key) in tableClassValue"
                                    :key="key"
                                    :label="item"
                                    :value="key">
                            </el-option>
                        </el-select>
                        <span class="demonstration">起止时间：</span>
                        <el-date-picker
                            v-model="datetimerangeValue"
                            type="month"
                            value-format='yyyy-MM'
                            placeholder="请选择月份"
                            :clearable='false'
                            style="width:250px;margin-right:20px">
                        </el-date-picker>
                        <el-button type="success" icon="el-icon-download" style="margin-right:10px;" @click="download">导出</el-button>
                        <el-button  type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
                    </div>
                </el-row>
                <div style="clear: both;"></div>
            </div>
            <div style="height: 10px;"></div>
            <div>
                <template>
                    <el-table :data="tableData" :height="th" border style="width: 100%;" align='center'>
                        <el-table-column prop="id" label="编号" width="85"></el-table-column>
                        <el-table-column prop="qxName" label="乡镇(街道)" v-if="!jwhShow"></el-table-column>
                        <el-table-column prop="qxName" label="村居" v-if="jwhShow"></el-table-column>
                        <el-table-column label="上月数据">
                            <el-table-column prop="lastTypeOne" label="70岁以上低保老人数"></el-table-column>
                            <el-table-column prop="lastTypeTwo" label="70岁以上无子女老人数"></el-table-column>
                            <el-table-column prop="lastTypeThree" label="90岁以上高龄老人数"></el-table-column>
                            <el-table-column prop="lastTotal" label="合计"></el-table-column>
                        </el-table-column>
                        <el-table-column label="本月数据">
                            <el-table-column prop="typeOne" label="70岁以上低保老人数"></el-table-column>
                            <el-table-column prop="typeTwo" label="70岁以上无子女老人数"></el-table-column>
                            <el-table-column prop="typeThree" label="90岁以上高龄老人数"></el-table-column>
                            <el-table-column prop="typeFour" label="当月新增人数"></el-table-column>
                            <el-table-column prop="typeFive" label="当月核减人数"></el-table-column>
                            <el-table-column prop="total" label="合计"></el-table-column>
                        </el-table-column>
                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    :current-page.sync="currentPage"  @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>
    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    // import elSelectTree from "../../components/ElSelectTree"
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,
                tableData:null,
                datetimerangeValue:'',
                jwhShow:false,
                totalItems: 0,
                showModal:false,
                pageSize:20,
                imgUrl:this.$imgUrl,
                currentPage:1,
                zoneValue:[],
                zoneCode:'00000000-0000-0000-0000-000000000000',
                th:0,
                name:'',
                downloadUrl:'ExportOldest/GetElderlyStatistics',
                ListUrl:'ExportOldest/GetElderlyStatisticsPage',
                fileName:'政府购买居家养老服务对象统计表(街道).xlsx',
                zoneProps:{
                    emitPath:false,
                    value: 'zoneCode',
                    // 显示的文字字段名
                    label: 'name',
                    // 子层级字段名
                    children: 'listZoneDTO'
                },
                tableClass:0,
                tableClassValue:['按街道统计','按村居统计']
            }
        },
        // components:{
        //     elSelectTree
        // },
        created(){
            this.init();
            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            
            init(){
                const end = new Date();
                // const start=new Date(end - 1000 * 60 * 60 * 24 * 30);
                this.datetimerangeValue=end;
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Zone/ListForStaff",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            var data=JSON.stringify(response.data.data);
                            data=JSON.parse(data.replace(/"listZoneDTO":\[\],/g,''))
                            this.zoneValue = data;
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },
            download(){
                this.$confirm('是否导出当前列表?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.showModal=true
                    console.log(getStaffCode())
                    var that=this
                    this.$axios.get(this.$shopUrl+this.downloadUrl,{
                        responseType: 'blob',
                        headers:{'Content-Type':'application/json'},
                        params:{
                            timeStr: timeStr,
                            sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                            staffCode: getStaffCode(),
                            time:this.datetimerangeValue
                        }
                    }).then(
                        (response) => {
                            if(response.data.type=='application/json'){
                                console.log(response)
                                this.$message({type: 'info', message: '暂无数据'});
                                that.showModal=false;
                            }else{
                                that.file(response,this.fileName)
                                that.showModal=false
                            }
                        }
                    )
                    this.dialogFormVisible=false
                }).catch(e=>e)
            },
            file(response,fileName){
                let blob = new Blob([response.data]);
                if (window.navigator.msSaveOrOpenBlob) {
                    navigator.msSaveBlob(blob,fileName);
                } else {
                    let elink = document.createElement("a");
                    elink.download = fileName;
                    elink.style.display = "none";
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href);
                    document.body.removeChild(elink);
                }
            },
            getTableClass(){
                if(this.tableClass){
                    this.downloadUrl='ExportOldest/GetElderlyStatisticsJWH'
                    this.ListUrl='ExportOldest/GetElderlyStatisticsJWHPage'
                    this.fileName = '政府购买居家养老服务对象统计表(村居).xlsx';
                }else{
                    this.downloadUrl='ExportOldest/GetElderlyStatistics';
                    this.ListUrl='ExportOldest/GetElderlyStatisticsPage';
                    this.fileName = '政府购买居家养老服务对象统计表(街道).xlsx';
                }
            },
            getZoneValue(val){
                this.zoneCode=val
            },
            getId(row, column, cellValue){
               return cellValue +1
            },
            getGender(row, column, cellValue){
                if(cellValue==0){
                    return '女'
                }else{
                    return '男'
                }
            },
            handleEdit(index, row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            getList(isSearch){
                if(isSearch)this.currentPage=1
                if(this.tableClass==1){
                    this.jwhShow=true
                }else{
                    this.jwhShow=false
                }
                console.log(this.datetimerangeValue)
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+this.ListUrl,
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        time:timefilters(this.datetimerangeValue).slice(0,7),
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                        this.$message.error(response.data.message)
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            statusTitle(row){
                if(row.status == 0){
                    return "正常";
                }
                if(row.status == 1){
                    return "禁用";
                }
                return "其它";
            },



        }
    }
</script>

<style  lang="scss" scoped>
.summary8099{
    .mask {
        background-color: rgb(0, 0, 0);
        opacity: 0.3;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 199
    }
    .mask .lodingsIcon{
        /* margin-top: 47vh; */
        margin: 47vh auto;
        height: 6vh;
        width: 300px;
        font-size: 18px;
        color: white;
    }
    .lodingsIcon i{
        z-index: 200;
        font-size: 25px;
        margin-right:10px ;
    }
}
</style>
